import React from 'react';
import './StoreBadges.css';

// Public store listings. Android shipped on Google Play as com.prozpects.prozpects
// (2026-07); iOS is the App Store listing id.
const IOS_URL = 'https://apps.apple.com/us/app/prozpects/id6759935775';
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.prozpects.prozpects';

/**
 * The standard two app-store badges (App Store + Google Play), height-normalized
 * so they line up despite different intrinsic aspect ratios. Same official
 * artwork used on prozpects.com/dl.
 */
export default function StoreBadges({ className = '' }) {
  return (
    <div className={`store-badges ${className}`.trim()}>
      <a
        href={IOS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-badge"
        aria-label="Download ProZpects on the App Store"
      >
        <img src="/badges/app-store.svg" alt="Download on the App Store" />
      </a>
      <a
        href={ANDROID_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-badge"
        aria-label="Get ProZpects on Google Play"
      >
        <img src="/badges/google-play.svg" alt="Get it on Google Play" />
      </a>
    </div>
  );
}
